
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/defi-lending-platform-development",
      function () {
        return require("private-next-pages/defi-lending-platform-development/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/defi-lending-platform-development"])
      });
    }
  